export const enum PaymentMethod {
  Cash = 0,
  CreditCard = 1,
  Invoice = 2,
  DirectBilling = 3,
}
